var _path, _rect, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H52C54.2091 0 56 1.79086 56 4V52C56 54.2091 54.2091 56 52 56H4C1.79086 56 0 54.2091 0 52V4Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 27,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#0075FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H52V-2H4V2ZM54 4V52H58V4H54ZM52 54H4V58H52V54ZM2 52V4H-2V52H2ZM4 54C2.89543 54 2 53.1046 2 52H-2C-2 55.3137 0.686294 58 4 58V54ZM54 52C54 53.1046 53.1046 54 52 54V58C55.3137 58 58 55.3137 58 52H54ZM52 2C53.1046 2 54 2.89543 54 4H58C58 0.686291 55.3137 -2 52 -2V2ZM4 -2C0.686291 -2 -2 0.686294 -2 4H2C2 2.89543 2.89543 2 4 2V-2Z",
    fill: "#E6E6E6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.0a32eab7.svg";
export { ForwardRef as ReactComponent };